(() => {
  if (!customElements.get("simple-dropdown")) {
    class SimpleDropdown extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        const header = this.querySelector(".filter-dropdown-item__header");
        if (header) {
          header.addEventListener("click", this.handleClick);
        }
      }

      disconnectedCallback() {
        const header = this.querySelector(".filter-dropdown-item__header");
        if (header) {
          header.removeEventListener("click", this.handleClick);
        }
      }

      handleClick() {
        this.classList.toggle("filter-dropdown-item--open");
      }
    }
    customElements.define("simple-dropdown", SimpleDropdown);
  }
})();
